import type { SearchSelectTexts } from '@platform/design-system';
import { usePageContext } from '../usePageContext.ts';

export const useSearchSelectTexts = (noMatch: string): SearchSelectTexts => {
  const { t } = usePageContext();
  return { loading: t('common.loadingMore'), loadMore: t('common.loadMore'), noMatch };
};
